export function makeStroke(stroke) {
    if (stroke === void 0) { stroke = false; }
    if (stroke === true) {
        return 'currentColor';
    }
    return undefined;
}
